export const HEADERS = {
  RECAPTCHA_TOKEN: 'recaptcha-token',
}

export const NEED_CAPTCHA = 'need_captcha'
export const INVALID_CAPTCHA = 'invalid_captcha'

export const makeHeadersWithRecaptcha = (token, otherHeaders = {}) => {
  if (token) otherHeaders[HEADERS.RECAPTCHA_TOKEN] = token
  return otherHeaders
}
